import { OfferingOptionModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class OfferingOptionService extends ApiService<OfferingOptionModel> {
	constructor() {
		super('offeringoption');
	}
}

export default new OfferingOptionService();
